import React from "react";
import { CONTACT } from "../lib/translations";
import { useLang } from "../lib/LanguageContext";
import { MessageCircle } from "lucide-react";

const WhatsAppFloat = () => {
  const { lang } = useLang();
  const msg = encodeURIComponent(
    lang === "mr"
      ? "नमस्कार! मला वनाझ परिवार शिक्षण मंडळ शाळेच्या प्रवेशाबद्दल माहिती हवी आहे."
      : "Hello! I'd like to know about admissions at Vanaz Parivar Shikshan Mandal."
  );
  const href = `https://wa.me/${CONTACT.whatsapp}?text=${msg}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-school-accent hover:bg-[var(--school-accent-dark)] text-white rounded-full pl-4 pr-5 py-3 shadow-2xl transition-all duration-300 hover:scale-105 group"
    >
      <div className="relative">
        <MessageCircle className="w-6 h-6" fill="currentColor" />
        <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-school-secondary rounded-full animate-pulse" />
      </div>
      <span className="hidden md:inline font-heading font-semibold text-sm">
        {lang === "mr" ? "WhatsApp वर चौकशी" : "Chat on WhatsApp"}
      </span>
    </a>
  );
};

export default WhatsAppFloat;
